/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  /* Adding an event listener to the range filter. This will update the pagination href value with the filter parameters */
  document.addEventListener('range:filter:update', (e) => {
    const searchFilterPaginationNum = [...document.querySelectorAll(".pagination-custom .pagination-custom__num a, .pagination-custom .pagination-custom__arr a")];
    for (const paginationNum of searchFilterPaginationNum) {
      // filter elements
      const priceFrom = document.querySelector(".filter__price__fields .filter__price__from input");
      const priceTo = document.querySelector(".filter__price__fields .filter__price__to input");

      const oldHRef = paginationNum.href;
      let filterParams = `&${priceFrom.name}=${priceFrom.value}&${priceTo.name}=${priceTo.value}`;
      let newHRef = `${oldHRef}${filterParams}`;
      paginationNum.href = newHRef;
    }
  });

  const productAccordionSelector = '.product-accordion';
  const productAccordionTriggerSelector = `${productAccordionSelector} [data-accordion-trigger]`;
  const productAccordionOpenClass = 'accordion-is-open';

  function getProductAccordionBody(trigger) {
    const bodyId = trigger.getAttribute('data-accordion-trigger');
    if (!bodyId) {
      return null;
    }

    const body = document.getElementById(bodyId);
    const accordion = trigger.closest(productAccordionSelector);

    return body && accordion && accordion.contains(body) ? body : null;
  }

  function setProductAccordionState(trigger, body, isOpen) {
    trigger.classList.toggle(productAccordionOpenClass, isOpen);
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    body.style.display = isOpen ? 'block' : 'none';
  }

  function closeProductAccordionSiblings(trigger) {
    const group = trigger.closest('[data-accordion-group]');
    if (!group) {
      return;
    }

    group.querySelectorAll('[data-accordion-trigger]').forEach((siblingTrigger) => {
      if (siblingTrigger === trigger) {
        return;
      }

      const siblingBody = getProductAccordionBody(siblingTrigger);
      if (siblingBody) {
        setProductAccordionState(siblingTrigger, siblingBody, false);
      }
    });
  }

  function initProductAccordions(scope = document) {
    scope.querySelectorAll(productAccordionTriggerSelector).forEach((trigger) => {
      const body = getProductAccordionBody(trigger);
      if (!body) {
        return;
      }

      trigger.setAttribute('aria-controls', body.id);
      trigger.setAttribute('aria-haspopup', 'true');
      setProductAccordionState(trigger, body, trigger.classList.contains(productAccordionOpenClass));
    });
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(productAccordionTriggerSelector);
    if (!trigger) {
      return;
    }

    const body = getProductAccordionBody(trigger);
    if (!body) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const shouldOpen = !trigger.classList.contains(productAccordionOpenClass);
    setProductAccordionState(trigger, body, shouldOpen);

    if (shouldOpen) {
      closeProductAccordionSiblings(trigger);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    initProductAccordions();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initProductAccordions(event.target);
  });
})();
